module.exports = __webpack_public_path__ + "static/kobe-5-367684cb5aa86eb3edab2e474ac44980.jpg";